// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page training-report {
  margin-top: 0.39in;
}
@page training-report:first {
  margin-top: 0;
}
html:has(.TrainingReportPdf) {
  page: training-report;
}

.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) {
  --pdf-width: 11in;
  --pdf-spacing: 0.39in;
  --training-navy: #1b3e6f;
  --training-border: #dde1e6;
  --training-text: #121619;
}
.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf {
  position: relative;
  display: flex;
  flex-direction: column;
  width: var(--pdf-width);
  min-height: 100vh;
  height: auto;
  color: var(--training-text);
}
.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf .SkyhopPdfHeader:before, .PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf .SkyhopPdfHeader:after {
  content: "";
  display: block;
  width: 0.8in;
  height: 5px;
  position: absolute;
  bottom: -5px;
}
.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf .SkyhopPdfHeader:before {
  background-color: #ff9e16;
  left: 0;
}
.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf .SkyhopPdfHeader:after {
  background-color: #40ade2;
  right: 0;
}
.PdfLayout .PdfLayout-Content:has(.TrainingReportPdf) .TrainingReportPdf .TrainingReportPdf-Content {
  flex-grow: 1;
  padding: 0 0.06in calc(var(--pdf-spacing) / 2) 0.06in;
}

.TrainingReportPdf-Summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  width: 100%;
  padding: 21px 0.9in 26px 0.9in;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Filters,
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis {
  width: 100%;
  justify-content: center;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Filters {
  display: flex;
  gap: 1.5rem;
  font-size: 12px;
  font-weight: 500;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis {
  display: flex;
  align-items: flex-end;
  gap: 54px;
  color: var(--training-navy);
  text-transform: uppercase;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi {
  display: flex;
  flex-direction: column;
  gap: 1px;
  max-width: 120px;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi[data-name="AVG TRAINING DURATION"] {
  position: relative;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi[data-name="AVG TRAINING DURATION"]:before, .TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi[data-name="AVG TRAINING DURATION"]:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: var(--training-navy);
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi[data-name="AVG TRAINING DURATION"]:before {
  left: -27px;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-Kpi[data-name="AVG TRAINING DURATION"]:after {
  right: -27px;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-KpiLabel {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.6px;
  line-height: 1.25;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-KpiValue {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.32px;
}
.TrainingReportPdf-Summary .TrainingReportPdf-Kpis .TrainingReportPdf-KpiValue small {
  font-size: 12px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/TrainingReport/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACA;EACE,aAAA;AACF;AACA;EACE,qBAAA;AACF;;AAGE;EACE,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EACA,wBAAA;AAAJ;AACI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,2BAAA;AACN;AACQ;EAEE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAAV;AAEQ;EACE,yBAAA;EACA,OAAA;AAAV;AAEQ;EACE,yBAAA;EACA,QAAA;AAAV;AAGM;EACE,YAAA;EACA,qDAAA;AADR;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;AAJF;AAKE;;EAEE,WAAA;EACA,uBAAA;AAHJ;AAKE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAHJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAFN;AAGM;EACE,kBAAA;AADR;AAEQ;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,sCAAA;AADV;AAGQ;EACE,WAAA;AADV;AAGQ;EACE,YAAA;AADV;AAKI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AAHN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAHN;AAIM;EACE,eAAA;EACA,gBAAA;AAFR","sourcesContent":["@page training-report {\n  margin-top: 0.39in;\n}\n@page training-report:first {\n  margin-top: 0;\n}\nhtml:has(.TrainingReportPdf) {\n  page: training-report;\n}\n\n.PdfLayout {\n  .PdfLayout-Content:has(.TrainingReportPdf) {\n    --pdf-width: 11in;\n    --pdf-spacing: 0.39in;\n    --training-navy: #1b3e6f;\n    --training-border: #dde1e6;\n    --training-text: #121619;\n    .TrainingReportPdf {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      width: var(--pdf-width);\n      min-height: 100vh;\n      height: auto;\n      color: var(--training-text);\n      .SkyhopPdfHeader {\n        &:before,\n        &:after {\n          content: '';\n          display: block;\n          width: 0.8in;\n          height: 5px;\n          position: absolute;\n          bottom: -5px;\n        }\n        &:before {\n          background-color: #ff9e16;\n          left: 0;\n        }\n        &:after {\n          background-color: #40ade2;\n          right: 0;\n        }\n      }\n      .TrainingReportPdf-Content {\n        flex-grow: 1;\n        padding: 0 0.06in calc(var(--pdf-spacing) / 2) 0.06in;\n      }\n    }\n  }\n}\n\n.TrainingReportPdf-Summary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n  width: 100%;\n  padding: 21px 0.9in 26px 0.9in;\n  .TrainingReportPdf-Filters,\n  .TrainingReportPdf-Kpis {\n    width: 100%;\n    justify-content: center;\n  }\n  .TrainingReportPdf-Filters {\n    display: flex;\n    gap: 1.5rem;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  .TrainingReportPdf-Kpis {\n    display: flex;\n    align-items: flex-end;\n    gap: 54px;\n    color: var(--training-navy);\n    text-transform: uppercase;\n    .TrainingReportPdf-Kpi {\n      display: flex;\n      flex-direction: column;\n      gap: 1px;\n      max-width: 120px;\n      &[data-name='AVG TRAINING DURATION'] {\n        position: relative;\n        &:before,\n        &:after {\n          content: '';\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          width: 2px;\n          background-color: var(--training-navy);\n        }\n        &:before {\n          left: -27px;\n        }\n        &:after {\n          right: -27px;\n        }\n      }\n    }\n    .TrainingReportPdf-KpiLabel {\n      font-size: 12px;\n      font-weight: 500;\n      letter-spacing: 0.6px;\n      line-height: 1.25;\n    }\n    .TrainingReportPdf-KpiValue {\n      font-size: 16px;\n      font-weight: 700;\n      letter-spacing: 0.32px;\n      small {\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
